import { SchoolContact } from "./school-contact";

export class BookingHighSchoolInfo {
    constructor(
        public schoolName: string,
        public schoolPhone: string,
        public schoolAddress: string,
        public schoolCity: string,
        public schoolPostCode: string,
        public schoolWebsiteUrl: string,
        public schoolEmail: string,
        public localCoordinatorName: string,
        public localCoordinatorPhone: string,
        public localCoordinatorEmail: string,
        public schoolCoordinatorName: string,
        public schoolCoordinatorPhone: string,
        public schoolCoordinatorEmail: string,
        public comment: string,
        public schoolContactList: SchoolContact[],
        public schoolId: number,
        public id?: number
    ) { }
}
